import { ICreateTask, IFilterTasks } from "../../modules/tasks/interface";
import { api } from "../api";

async function createTask({ query, body }: ICreateTask) {
  await api.post(
    `/task?application=${query.application}&creatorName=${query.creatorName}`,
    body
  );
}

async function tasks({ page, limit, idFarm }: IFilterTasks) {
  const { data } = await api.get(
    `/task/farm?page=${page}&limit=${limit}&idFarm=${idFarm}`
  );

  return data;
}

async function loadTaskById(id: string) {
  const { data } = await api.get(`/task/${id}`);

  return data;
}

export { createTask, tasks, loadTaskById };
